import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { RanchFertilizerViewModel } from './interfaces';
import { FertilizerBaseDialog, FertilizerDialogData } from './fertilizer.dialog.base';
import { FertilizerModelService } from './service';
import { FormGroup } from '@angular/forms';
import { UpdateService } from '../../../../services/update.service';
import { eFertilizerFormulationTypes } from '../../../../interfaces/constants';
import { ObjectUtility } from '../../../../classes/objectUtility';

@Component({
	moduleId: module.id,
	selector: 'fertilizer-edit-dialog',
	templateUrl: 'fertilizer.edit.dialog.html'
})

export class FertilizerEditDialog extends FertilizerBaseDialog implements OnInit {

	public fertilizer: RanchFertilizerViewModel;
	public isFormValid = true;
	public isTouched = false;
	public isSaving: boolean;

	public constructor(
		protected _dialog: MatDialog,
		private _dialogRef: MatDialogRef<FertilizerEditDialog>,
		@Inject(MAT_DIALOG_DATA) protected _data: FertilizerDialogData,
		private service: FertilizerModelService,
		private updateService: UpdateService
	) {
		super(_dialog, _data);
	}

	ngOnInit(): void {
		this.isSaving = false;
		this._getEditModel(this.id);
	}

	public close() {
		if (!this.isTouched) {
			this._dialogRef.close();
		} else {
			this._openKeepDiscardDialog();
		}
	}

	/**
	 * editRanchFertilzer
	 */
	public save(): void {
		if (this.isSaving) {
			return;
		}

		let model: RanchFertilizerViewModel;

		model = ObjectUtility.copy(this.fertilizer);
		model = this._convertPercentages(model);

		this.isSaving = true;

		if (this.id) {
			this.service.update(this.id, model)
			.then(() => {
				this.isSaving = false;
				this.updateService.setRanchSettingsUpdated('fertilizers');
				this._dialogRef.close();
			});
		} else {
			// this dialog is only triggered for creation in the admin section. A
			// different dialog is opened in ranch settings.
			this.service.addSystem(model)
			.then(() => {
				this.isSaving = false;
				this.updateService.setRanchSettingsUpdated('fertilizers');
				this._dialogRef.close();
			});
		}
	}

	private _convertPercentages(model: RanchFertilizerViewModel): RanchFertilizerViewModel {
		if (!model.IsChemical && model.OrganicFertilizer) {
			model.OrganicFertilizer.DryMatter = this._fixRounding(model.OrganicFertilizer.DryMatter / 100);
			model.OrganicFertilizer.FOMFastFraction = this._fixRounding(model.OrganicFertilizer.FOMFastFraction / 100);
			model.OrganicFertilizer.MineralNitrogen = this._fixRounding(model.OrganicFertilizer.MineralNitrogen / 100);
			model.OrganicFertilizer.TotalNitrogen = this._fixRounding(model.OrganicFertilizer.TotalNitrogen / 100);
		}

		return model;
	}

	/**
	 * Prevent or allow user to save based on form validation.
	 * If user touched the form, ask for keep/discard instead of immediately closing the dialog
	 */
	public updateFormState(form: FormGroup): void {
		if (!form) {
			return;
		}

		this.isTouched = form.pristine ? false : true;
		this.isFormValid = form.invalid ? false : true;
	}

	private _getEditModel(id: number): void {
		if (id) {
			this.service.getEditModel(id)
			.then(data => {

				if (!data) {
					return;
				}

				this.fertilizer = data;

				if (this.fertilizer.OrganicFertilizer) {
					this.fertilizer.OrganicFertilizer.DryMatter = this._fixRounding(this.fertilizer.OrganicFertilizer.DryMatter * 100);
					this.fertilizer.OrganicFertilizer.FOMFastFraction = this._fixRounding(this.fertilizer.OrganicFertilizer.FOMFastFraction * 100);
					this.fertilizer.OrganicFertilizer.MineralNitrogen = this._fixRounding(this.fertilizer.OrganicFertilizer.MineralNitrogen * 100);
					this.fertilizer.OrganicFertilizer.TotalNitrogen = this._fixRounding(this.fertilizer.OrganicFertilizer.TotalNitrogen * 100);
				}
			});
		} else {
			this.service.getCreateModel().then(data => {
				this.fertilizer = data;
				this.fertilizer.FormulationTypeId = eFertilizerFormulationTypes.DRY;
			});
		}
	}

	private  _fixRounding(x: number) {
		return Number(x.toFixed(4));
	}
}
